import { z } from "zod";

// form zod validation schema
export const createDisclaimerSchema = z.object({
  value: z.string().optional(),
});

// generate form types from zod validation schema
export type CreateDisclaimerInput = z.infer<typeof createDisclaimerSchema>;
